import React from "react";
import {Select} from "antd";
import {injectIntl} from "react-intl";
import Constants from "../../../services/Constants";

const Option = Select.Option;

class CategorySelector extends React.Component {

  render() {
    const {intl:{formatMessage}, ...attributes} = this.props;

    const options = Constants.RENTAL_CATEGORIES.map(r =>
      <Option value={r.value} key={r.value}>{formatMessage(r.label)}</Option>
    );

    return (
      <Select style={{width: '100%'}} {...attributes}>
        {options}
      </Select>
    )
  }
}

export default injectIntl(CategorySelector);
